<template>
  <div
    v-if="fileInfoDetail && fileInfoDetail.length && ready"
    id="mediaPreview"
    class="media-full-preview"
  >
    <div v-for="i in [currentIndex]" :key="i" class="file-wrapper-preview">
      <div class="file-wrapper">
        <audio
          v-if="fileInfoDetail[0].type == 'audio'"
          class="file audio"
          :class="{ 'file-shadow': !isMobileDevice }"
          :src="currentFile.file_url"
          controlsList="nodownload"
          controls
        ></audio>
        <img
          v-if="
            fileInfoDetail[0].type === 'image' &&
            (currentFile.file_url || currentFile.thumbnail)
          "
          :key="currentFile.unique_id"
          id="image"
          class="file"
          :class="{ 'file-shadow': !isMobileDevice }"
          :src="currentFile.file_url || currentFile.thumbnail"
        />
        <div
          v-if="fileInfoDetail[0].type === 'video' && currentFile.file_url"
          class="video-wrapper"
        >
          <video
            :src="currentFile.file_url"
            class="video"
            :class="{ 'file-shadow': !isMobileDevice }"
            controlsList="nodownload"
            disablePictureInPicture
            playsinline
            controls
            autoplay
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { events } from '@main/js/bus'
import { mapGetters } from 'vuex'
// import ToolbarButton from '@assets/js/components/ToolbarButton'
// import Spinner from '@assets/js/components/Spinner'

export default {
  name: 'MediaFullPreview',
  components: {
    /* ToolbarButton, Spinner*/
  },
  data() {
    return {
      currentIndex: 1,
      sliderFile: [],
      ready: false,
      // loaded: false
    }
  },
  computed: {
    ...mapGetters(['fileInfoDetail', 'data', 'dataPreview']),

    isMobileDevice() {
      return this.$isMobile()
    },

    currentFile() {
      if (!this.sliderFile || this.sliderFile.length === 0) return {}
      const idx = Math.abs(this.currentIndex) % this.sliderFile.length
      return this.sliderFile[idx]
    },
    isMedia() {
      const t =
        this.fileInfoDetail && this.fileInfoDetail[0]
          ? this.fileInfoDetail[0].type
          : null
      return t === 'image' || t === 'video' || t === 'audio'
    },

    canShareInView() {
      return !this.$isThisLocation([
        'base',
        'participant_uploads',
        'latest',
        'shared',
        'public',
      ])
    },
  },
  watch: {
    sliderFile() {
      //Close file preview after delete all items
      if (this.sliderFile.length == 0) {
        events.$emit('fileFullPreview:hide')
      }
    },
    currentFile() {
      // Keep context menu in sync (no store mutations to avoid loops)
      if (this.fileInfoDetail[0]) {
        events.$emit('actualShowingImage:ContextMenu', this.currentFile)
      }
    },
    fileInfoDetail() {
      // Rebuild slider when current file changes; avoid store commits here
      if (this.fileInfoDetail && this.fileInfoDetail[0]) {
        this.sliderFile = []
        this.filteredFiles()
      }
    },
    data(newValue, oldValue) {
      // Update slider when source list changes
      if (newValue != oldValue) {
        this.sliderFile = []
        this.filteredFiles()
      }
    },
  },
  mounted() {
    if (this.sliderFile.length > 1) {
      events.$on('filePreviewAction:next', () => {
        this.currentIndex += 1
        this.slideType = 'next'
        if (this.currentIndex > this.sliderFile.length - 1) {
          this.currentIndex = 0
        }
      })
      events.$on('filePreviewAction:prev', () => {
        this.slideType = 'prev'
        this.currentIndex -= 1
        if (this.currentIndex < 0) {
          this.currentIndex = this.sliderFile.length - 1
        }
      })
    }
    // Reset on hide to avoid stale flash
    events.$on('fileFullPreviewMode:hide', () => {
      this.ready = false
      this.sliderFile = []
    })
  },
  created() {
    this.filteredFiles()
  },
  methods: {
    filteredFiles() {
      // Guard against undefined state
      if (!this.fileInfoDetail || !this.fileInfoDetail[0]) return
      this.ready = false
      const file = this.fileInfoDetail[0]
      const source =
        this.dataPreview && this.dataPreview.length
          ? this.dataPreview
          : this.data || []
      this.sliderFile = []
      if (!source.length) {
        // Fallback: at least preview the current file
        this.sliderFile = [file]
      } else {
        source.forEach((element) => {
          if (element && element.type === file.type) {
            this.sliderFile.push(element)
          }
        })
        if (!this.sliderFile.length) this.sliderFile = [file]
      }
      this.choseActiveFile()
      this.$nextTick(() => { this.ready = true })
    },
    choseActiveFile() {
      if (!this.fileInfoDetail || !this.fileInfoDetail[0]) return
      const uid = this.fileInfoDetail[0].unique_id
      this.sliderFile.forEach((element, index) => {
        if (element && element.unique_id === uid) {
          this.currentIndex = index
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.media-full-preview {
  height: calc(100% - 63px);
  top: 63px;
  position: relative;
  background-color: rgba(255, 255, 255, 0.14);
}

.navigation-panel {
  width: 100%;
  height: 7%;
  display: flex;
  align-items: center;
  padding: 20px;
  justify-content: space-between;
  background-color: $light-background;
  color: $text;
  .icon-close {
    color: $text;
    @include font-size(21);
    &:hover {
      color: $theme;
    }
  }
}

.loading-spinner {
  position: relative;
}

.file-wrapper-preview {
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  background-color: rgba(82, 95, 117, 0.84);

  .file-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .file-shadow {
      box-shadow: 0 8px 40px rgba(17, 26, 52, 0.5);
    }

    .file {
      max-width: 100%;
      max-height: 100%;
      align-self: center;
    }

    .audio {
      border-radius: 28px;
    }

    img {
      border-radius: 6px;
    }

    .video-wrapper {
      max-width: 1080px;
      max-height: 100%;

      @media (min-width: 1200px) {
        & {
          max-width: 800px;
        }
      }

      @media (min-width: 1920px) and (max-width: 2560px) {
        & {
          max-width: 1080px;
        }
      }
      @media (min-width: 2560px) and (max-width: 3840px) {
        & {
          max-width: 1440px;
        }
      }
      @media (min-width: 3840px) {
        & {
          max-width: 2160px;
        }
      }
      .video {
        max-width: 100%;
        max-height: 100%;
        align-self: center;
      }
    }
  }
}
</style>
